import React, { useEffect, useState, useCallback, ChangeEvent } from "react";
import { Button, Card, MenuItem, useTheme } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "src/store/Store";
import { PageContainer, Breadcrumb } from "../common";
import Loading from "../common/Loading";
import { selectUserCompany } from "src/store/authSlice";
import { client } from "src/common/axiosClient";
import Modal from "../common/Modal";
import { useNavigate } from "react-router";
import moment from "moment";

export default function MaunalTheraistMetaTable({ id }: any) {
  const navigate = useNavigate();
  const theme = useTheme();

  const borderColor = theme.palette.divider;

  const [isLoding, setLoding] = useState<boolean>(false);
  const [schedule, setSchedule] = useState<any>({});
  const [activeButton, setActiveButton] = useState("today");
  const labelDay: any = {
    monday: "월",
    tuesday: "화",
    wednesday: "수",
    thursday: "목",
    friday: "금",
    saturday: "토",
    sunday: "일",
  };
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const timePeriods = ["morning", "afternoon", "night"];

  useEffect(() => {
    getDoctorMeta();
  }, []);

  const getDoctorMeta = async () => {
    try {
      setSchedule({});
      const response = await client.get(
        `admin/api/v1/schedule-meta/MANUAL_THERAPIST/${id}`
      );
      if (response.status === 200) {
        console.log(response);
        if (response.data.content) {
          let data = response.data.content;
          setSchedule(data);
        }
      } else {
        console.error(
          "Failed to fetch doctor meta data with status: ",
          response.status
        );
      }
    } catch (error) {
      console.error(
        "An error occurred while fetching doctor meta data: ",
        error
      );
    }
  };

  const [launchStartAt, setLaunchStartAt] = useState<string>("13:00");
  const [launchEndAt, setLaunchEndAt] = useState<string>("14:00");

  const formatTime = (timeSlot: any) => {
    return timeSlot
      ? `${timeSlot.startAt.slice(0, -3)}~${timeSlot.endAt.slice(0, -3)}`
      : "휴진";
  };

  return (
    <>
      {Object.keys(schedule).length > 0 ? (
        <table className="min-w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="border border-gray-300 text-center w-10 bg-[#212d62] text-white">
                요일
              </th>
              <th className="border border-gray-300  text-center bg-[#212d62] text-white">
                오전
              </th>
              <th className="border border-gray-300  text-center bg-[#212d62] text-white">
                점심
              </th>
              <th className="border border-gray-300  text-center bg-[#212d62] text-white">
                오후
              </th>
              <th className="border border-gray-300  text-center bg-[#212d62] text-white">
                야간
              </th>
            </tr>
          </thead>
          <tbody>
            {days.map((day) => {
              const daySchedule = schedule[day];
              return (
                <tr key={day} className="hover:bg-slate-200">
                  <td className="border border-gray-300 bg-blue-100 text-center font-semibold capitalize">
                    {labelDay[day]}
                  </td>

                  <td
                    className={`border border-gray-300 text-center ${
                      daySchedule && formatTime(daySchedule.morning) === "휴진"
                        ? "bg-red-600 text-white"
                        : ""
                    }`}
                  >
                    {daySchedule ? formatTime(daySchedule.morning) : "휴진"}
                  </td>
                  <td
                    className={`border border-gray-300 text-center ${
                      daySchedule && formatTime(daySchedule.lunch) === "휴진"
                        ? "bg-red-600 text-white"
                        : ""
                    }`}
                  >
                    {daySchedule ? formatTime(daySchedule.lunch) : "휴진"}
                  </td>
                  <td
                    className={`border border-gray-300 text-center ${
                      daySchedule &&
                      formatTime(daySchedule.afternoon) === "휴진"
                        ? "bg-red-600 text-white"
                        : ""
                    }`}
                  >
                    {daySchedule ? formatTime(daySchedule.afternoon) : "휴진"}
                  </td>

                  <td
                    className={`border border-gray-300 text-center ${
                      daySchedule && formatTime(daySchedule.night) === "휴진"
                        ? "bg-red-600 text-white"
                        : ""
                    }`}
                  >
                    {daySchedule ? formatTime(daySchedule.night) : "휴진"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div className="font-semibold">기본 스케줄이 없습니다.</div>
      )}
    </>
  );
}
